import { Box } from "@mui/material";
import { Outlet } from "react-router";
import UserSettingsMenu from "./menu/UserSettingsMenu";
import SettingsLayout from "./SettingsLayout";

const UserSettingsPage = () => {
  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", flex: 1, overflowY: "auto" }}>
      <SettingsLayout menu={<UserSettingsMenu />}>
        <Outlet />
      </SettingsLayout>
    </Box>
  );
};

export default UserSettingsPage;
